import type { ScreenFactory } from "../../taskScreenRegistry";

import {
  createPropertiesScreens,
  createPropertyLoansScreens,
  createPropertyInsuranceScreens,
} from "./real_estate";

export const realEstateTasks: Record<string, ScreenFactory> = {
  properties: createPropertiesScreens,
  property_loans: createPropertyLoansScreens,
  property_insurance: createPropertyInsuranceScreens,
};
